<template>
    <span :class="type" class="badge"> {{ text }} </span>
</template>

<script>
export default {
    props:['type','title'],
    computed:{
        text(){
            return this.title.toUpperCase();
        }
    }
}
</script>

<style scoped>
.badge {
  background-color: #ccc;
  color: #252525;
  border-radius: 30px;
  padding: 0.5rem 0.5rem;
  display: inline-block;
  margin-right: 0.5rem;
}

.frontend {
  background-color: #3d008d;
  color: white;
  font-size :13px;
}

.backend {
  background-color: #71008d;
  color: white;
  font-size :13px;
}

.career {
  background-color: #8d006e;
  color: white;
  font-size :13px;
}
</style>